// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardGridContent.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { PropTypes, Component } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import { observer } from 'mobx-react';
import GridView from 'share/components/controls/GridLayout/Izenda.GridView';
import GridItem from 'share/components/controls/GridLayout/Izenda.GridItem';
import DashboardTileContent from './DashboardTile/Izenda.DashboardTileContent';
import Dimensions from 'share/components/hoc/Izenda.Dimensions';
import DashboardGridLayoutUIStore from './Izenda.DashboardGridLayoutUIStore';
import { find, get, placeholder } from 'lodash/fp';

@connect(Dimensions)
class DashboardDesignerGrid extends Component {
  static displayName = 'DashboardDesignerGrid';

  static propTypes = {
    store: PropTypes.object.isRequired,
    width: PropTypes.number.isRequired
  };

  constructor(props) {
    super(props);

    this.layoutStore = null;
    this.parts = [];

    const width = props.width;
    const dashboardDetail = this.props.store.dashboardDetail;

    this.layoutStore = new DashboardGridLayoutUIStore(width, dashboardDetail.dashboard.transparentDashboardGrid, true);
    this.initParts(this.props);
  }

  componentWillReceiveProps(nextProps: any) {
    const nextReportParts = this.getParts(nextProps);

    this.parts.length != nextReportParts.length && this.initParts(nextProps);
  }

  /**
   * Get active parts.
   */
  getParts({ store }): any {
    return get('dashboardDetail.dashboard.activeDashboardParts', store);
  }

  /**
   * Prepare parts for printing
   */
  initParts(props: any) {
    this.parts = this.getParts(props);
  }

  toLayoutItem(item: any): any {
    return {
      id: item.id,
      x: item.positionX,
      y: item.positionY,
      width: item.width,
      height: item.height,
      isFullSize: item.isFullSize,
      autoSize: item.reportPart && item.reportPart.autoSize
    };
  }

  render() {
    const { store, printingMode, renderListeners, cellWidth } = this.props;
    const layoutData = this.parts.map(this.toLayoutItem);

    this.parts = placeholder(this.parts.slice())
      .sortBy(['positionY', 'positionX'])
      .value();

    const gridItems = this.parts.map(dashboardPart => {
      const renderListener = find(listener => listener.partId === dashboardPart.id, renderListeners);

      return (
        <GridItem
          key={dashboardPart.id}
          id={dashboardPart.id}
          isDraggable={false}
          isResizable={false}
          printingMode={printingMode}
          cancel=".btn, input, a[href]"
        >
          <DashboardTileContent
            printingMode={printingMode}
            dashboardDetail={store.dashboardDetail}
            store={store}
            dashboardPart={dashboardPart}
            finishedRender={renderListener && renderListener.resolve}
            cellWidth={cellWidth}
          />
        </GridItem>
      );
    });

    return (
      <section className="Izenda-DashboardGrid_Section">
        <GridView
          className="izenda-DashboardGrid"
          layoutStore={this.layoutStore}
          layoutData={layoutData}
          forDashboard
          printingMode={printingMode}
        >
          {gridItems}
        </GridView>
      </section>
    );
  }
}

export default DashboardDesignerGrid;



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardDesigner/DashboardGrid/Izenda.DashboardGridContent.js